import { render, staticRenderFns } from "./addWarning.vue?vue&type=template&id=193e24e5&scoped=true&"
import script from "./addWarning.vue?vue&type=script&lang=js&"
export * from "./addWarning.vue?vue&type=script&lang=js&"
import style0 from "./addWarning.vue?vue&type=style&index=0&id=193e24e5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193e24e5",
  null
  
)

export default component.exports